const resendEmail = {
  '¡Estás a un paso de empezar a postularte!': '¡Te damos la bienvenida!',
  'Puedes editar todos tus datos desde tu perfil.': 'Puedes editar todos tus datos desde tu perfil.',
}

export default resendEmail
